import { merchantAdminSplitApi } from './apiBase';

type Severity = 'Info' | 'Success' | 'Warning' | 'Error';
type ScanImageConfiguration = 'None' | 'Profile' | 'Detailed';

export type BoddRegion = 'Unknown' | 'AU' | 'US' | 'USWEST' | 'EU' | 'UK';

export type UserNotificationDto = {
    id?: number;
    merchantId?: number | null;
    header?: string | null;
    detail?: string | null;
    severity?: Severity;
    path?: string | null;
    from?: string | null;
    to?: string | null;
    action?: string | null;
    actionText?: string | null;
    filterFunction?: string | null;
};

export type MerchantSummaryDto = {
    id?: number;
    name?: string | null;
    region?: BoddRegion;
    qualityAssuranceHoldEnabled?: boolean;
    sizeMatchEnabled?: boolean;
    rawScanDownloadEnabled?: boolean;
    objScanDownloadEnabled?: boolean;
    measurementsDownloadEnabled?: boolean;
    cohortTrackingEnabled?: boolean;
    scanImageConfiguration?: ScanImageConfiguration;
};

export type MerchantUserContext = {
    allMerchants?: MerchantSummaryDto[] | null;
    userMerchant?: MerchantSummaryDto;
    regionMap?: {
        Unknown?: string;
        AU?: string;
        US?: string;
        USWEST?: string;
        EU?: string;
        UK?: string;
    } | null;
    notifications?: UserNotificationDto[] | null;
};

const injectedApi = merchantAdminSplitApi.injectEndpoints({
    endpoints: (build) => ({
        userContextControllerRetrieveUserContext: build.query<MerchantUserContext, void>({
            query: () => ({ url: `/user-context` }),
            providesTags: ['UserContext'],
        }),
    }),
    overrideExisting: true,
});

export const {
    useUserContextControllerRetrieveUserContextQuery,
    useLazyUserContextControllerRetrieveUserContextQuery,
} = injectedApi;
